window.PuurePov2BundleInit = function (cfg) {

  'use strict';

  var wrap = document.getElementById('po-v2-' + cfg.uid);
  if (!wrap) return;

  var uid = cfg.uid;
  var S   = (window.__PUURE__ && window.__PUURE__[uid]) || {};
  var SUP = (window.__PUURE_SUPPLY__ && window.__PUURE_SUPPLY__[uid]) || {};

  var cards = Array.from(wrap.querySelectorAll('.pov2-card'));
  var btn   = wrap.querySelector('[data-po-btn]');
  var btnPrice = btn ? btn.querySelector('.pov2-btn__price') : null;

  var currentVariantId = S.defaultVariantId;
  var subTerm = '6m';
  var onetimeTerm = '6m';
  var bundleTerm = '3m';

  function getCurrency(str) { return (str || '\u00a3').replace(/[0-9.,\s]/g, '') || '\u00a3'; }
  function fmt(n, cur) {
    if (window.PuureMoney) return window.PuureMoney.formatUnits(n);
    var val = (Math.round(n * 100) / 100).toFixed(2);
    /* Comma decimal + symbol after for EUR-style currencies */
    if (cur === '€' || cur === 'kr' || cur === 'zł' || cur === 'Kč') {
      val = val.replace('.', ',');
      return val + '\u00a0' + cur;
    }
    return cur + val;
  }
  function parsePrice(str) {
    /* Handle both 80.00 (en) and 80,00 (eu) formats */
    var s = (str || '0').replace(/[^0-9.,]/g, '');
    /* If has comma and no dot, or comma after dot: comma is decimal */
    if (s.indexOf(',') > -1) {
      var lastComma = s.lastIndexOf(',');
      var lastDot = s.lastIndexOf('.');
      if (lastComma > lastDot) {
        /* comma is decimal separator: 1.234,56 or 80,00 */
        s = s.replace(/\./g, '').replace(',', '.');
      }
    }
    return parseFloat(s) || 0;
  }
  function centsToUnit(n) { return Math.round(n) / 100; }

  /* ── Sync bullet text ── */
  var bulletMain = wrap.querySelector('.js-bullet-main');
  function syncBullets() {
    if (!bulletMain) return;
    var svgWrap = '<span class="pov2-gift__check-wrap"><svg class="pov2-gift__check" viewBox="0 0 16 16" fill="none"><path d="M3 8.5l3.5 3.5L13 4" stroke="#2764FF" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
    var bulletShort = (SUP.bullet_sub_short) ? SUP.bullet_sub_short : 'Auto cartridge delivery every <strong>6 months</strong>';
    var bulletLong  = (SUP.bullet_sub_long)  ? SUP.bullet_sub_long  : 'Auto cartridge delivery every <strong>1 year</strong>';
    if (SUP.seg_show_total) {
      /* Append dynamic subscription price to bullet */
      var CUR_BULLET = (S.currencySymbolFromLocale) || '$';
      var vp_b = S.variantPrices ? S.variantPrices[String(currentVariantId)] : null;
      if (vp_b) CUR_BULLET = getCurrency(vp_b.price_str) || CUR_BULLET;
      var sub6Price = centsToUnit((SUP.tap && SUP.tap['6m_sub']) ? SUP.tap['6m_sub'].price_then_cents : 0);
      var sub1yPrice = centsToUnit((SUP.tap && SUP.tap['1y_sub']) ? SUP.tap['1y_sub'].price_then_cents : 0);
      var priceSuffix;
      if (subTerm === '1y') {
        priceSuffix = ' (' + fmt(sub1yPrice, CUR_BULLET) + '/' + (SUP.seg_sub_long_period || '1 year') + ')';
        bulletMain.innerHTML = svgWrap + '<span class="pov2-gift__bullet-text">' + bulletLong + priceSuffix + '</span>';
      } else {
        priceSuffix = ' (' + fmt(sub6Price, CUR_BULLET) + '/' + (SUP.seg_sub_short_period || '4 months') + ')';
        bulletMain.innerHTML = svgWrap + '<span class="pov2-gift__bullet-text">' + bulletShort + priceSuffix + '</span>';
      }
    } else {
      if (subTerm === '1y') {
        bulletMain.innerHTML = svgWrap + '<span class="pov2-gift__bullet-text">' + bulletLong + '</span>';
      } else {
        bulletMain.innerHTML = svgWrap + '<span class="pov2-gift__bullet-text">' + bulletShort + '</span>';
      }
    }
  }

  /* ── Render prices ── */
  function renderPrices() {
    var vp = S.variantPrices ? S.variantPrices[String(currentVariantId)] : null;
    if (!vp) return;
    var CUR = S.currencySymbolFromLocale || getCurrency(vp.price_str);

    var sub6Then  = centsToUnit((SUP.tap && SUP.tap['6m_sub']) ? SUP.tap['6m_sub'].price_then_cents : 0);
    var sub6Cmp   = centsToUnit((SUP.tap && SUP.tap['6m_sub']) ? SUP.tap['6m_sub'].compare_onetime_cents : 0);
    var sub1yThen = centsToUnit((SUP.tap && SUP.tap['1y_sub']) ? SUP.tap['1y_sub'].price_then_cents : 0);
    var sub1yCmp  = centsToUnit((SUP.tap && SUP.tap['1y_sub']) ? SUP.tap['1y_sub'].compare_onetime_cents : 0);

    var ot6m  = centsToUnit((SUP.tap && SUP.tap['6m_ot']) ? SUP.tap['6m_ot'].price_onetime_cents : 0);
    var ot6mC = centsToUnit((SUP.tap && SUP.tap['6m_ot']) ? SUP.tap['6m_ot'].compare_onetime_cents : 0);
    var ot1y  = centsToUnit((SUP.tap && SUP.tap['1y_ot']) ? SUP.tap['1y_ot'].price_onetime_cents : 0);
    var ot1yC = centsToUnit((SUP.tap && SUP.tap['1y_ot']) ? SUP.tap['1y_ot'].compare_onetime_cents : 0);

    /* System price for gift box */
    var isSystemFree = !!(SUP.system_free);
    var sysPrice   = vp.price_str;
    var sysFullNum = parsePrice(sysPrice);
    var sysPriceNum = isSystemFree ? 0 : Math.round(sysFullNum * 50) / 100; /* free or -50% */
    var giftCompare = wrap.querySelector('[data-gift-compare]');
    var giftOtCompare = wrap.querySelector('[data-gift-ot-compare]');
    var giftSysPrice = wrap.querySelector('[data-gift-sys-price]');
    var giftOtSysPrice = wrap.querySelector('[data-gift-ot-sys-price]');
    if (isSystemFree) {
      /* Tap: system is free — show "Free" label, strike-through original price */
      var freeLabel = cfg.labelFree;
      if (giftCompare) { giftCompare.textContent = fmt(sysFullNum, CUR); }
      if (giftOtCompare) { giftOtCompare.textContent = fmt(sysFullNum, CUR); }
      if (giftSysPrice) { giftSysPrice.textContent = freeLabel; giftSysPrice.classList.add('pov2-gift__now--free'); }
      if (giftOtSysPrice) { giftOtSysPrice.textContent = freeLabel; giftOtSysPrice.classList.add('pov2-gift__now--free'); }
    } else {
      /* Shower: system at -50% */
      if (giftCompare) giftCompare.textContent = fmt(sysFullNum, CUR);
      if (giftOtCompare) giftOtCompare.textContent = fmt(sysFullNum, CUR);
      if (giftSysPrice) giftSysPrice.textContent = fmt(sysPriceNum, CUR);
      if (giftOtSysPrice) giftOtSysPrice.textContent = fmt(sysPriceNum, CUR);
    }

    /* Cartridge price in gift box (sub card) */
    var activeSeg = wrap.querySelector('[data-segs="sub"] .pov2-seg--active');
    var activeTerm = activeSeg ? activeSeg.getAttribute('data-term') : '6m';
    var cartPrice = activeTerm === '1y' ? sub1yThen : sub6Then;
    var cartCompare = activeTerm === '1y' ? (sub1yCmp > 0 ? sub1yCmp : ot1y) : sub6Cmp;
    var giftCartPrice = wrap.querySelector('[data-gift-cart-price]');
    var giftCartCompare = wrap.querySelector('[data-gift-cart-compare]');
    if (giftCartPrice) giftCartPrice.textContent = fmt(cartPrice, CUR);
    if (giftCartCompare) {
      if (cartCompare > cartPrice) { giftCartCompare.textContent = fmt(cartCompare, CUR); giftCartCompare.style.display = ''; }
      else { giftCartCompare.textContent = ''; giftCartCompare.style.display = 'none'; }
    }

    /* Update cartridge qty label + image (sub) — crossfade */
    var subQtyEl = wrap.querySelector('[data-cart-title="sub"] [data-cart-qty]');
    if (subQtyEl) subQtyEl.textContent = activeTerm === '1y' ? (SUP.qty_long || '4') : (SUP.qty_short || '2');
    var subCard = wrap.querySelector('[data-mode="sub_only"]');
    if (subCard) {
      var sub2c = subCard.querySelector('[data-cart-img-2c]');
      var sub4c = subCard.querySelector('[data-cart-img-4c]');
      if (sub2c) { sub2c.style.opacity = activeTerm === '1y' ? '0' : '1'; sub2c.style.position = activeTerm === '1y' ? 'absolute' : ''; sub2c.style.pointerEvents = activeTerm === '1y' ? 'none' : ''; }
      if (sub4c) { sub4c.style.display = ''; sub4c.style.opacity = activeTerm === '1y' ? '1' : '0'; sub4c.style.position = activeTerm === '1y' ? '' : 'absolute'; sub4c.style.pointerEvents = activeTerm === '1y' ? '' : 'none'; }
    }

    /* Cartridge price in gift box (one-time card) */
    var otActiveSeg = wrap.querySelector('[data-segs="ot"] .pov2-seg--active');
    var otActiveTerm = otActiveSeg ? otActiveSeg.getAttribute('data-term') : '6m';
    var otCartPrice = otActiveTerm === '1y' ? ot1y : ot6m;
    var otCartCompare = otActiveTerm === '1y' ? ot1yC : ot6mC;
    var giftOtCartPrice = wrap.querySelector('[data-gift-ot-cart-price]');
    var giftOtCartCompare = wrap.querySelector('[data-gift-ot-cart-compare]');
    if (giftOtCartPrice) giftOtCartPrice.textContent = fmt(otCartPrice, CUR);
    if (giftOtCartCompare) {
      if (otCartCompare > otCartPrice) { giftOtCartCompare.textContent = fmt(otCartCompare, CUR); giftOtCartCompare.style.display = ''; }
      else { giftOtCartCompare.textContent = ''; giftOtCartCompare.style.display = 'none'; }
    }

    /* Update cartridge qty label + image (one-time) — crossfade */
    var otQtyEl = wrap.querySelector('[data-cart-title="ot"] [data-cart-qty]');
    if (otQtyEl) otQtyEl.textContent = otActiveTerm === '1y' ? (SUP.qty_long || '4') : (SUP.qty_short || '2');
    var otCard = wrap.querySelector('[data-mode="onetime"]');
    if (otCard) {
      var ot2c = otCard.querySelector('[data-cart-img-2c]');
      var ot4c = otCard.querySelector('[data-cart-img-4c]');
      if (ot2c) { ot2c.style.opacity = otActiveTerm === '1y' ? '0' : '1'; ot2c.style.position = otActiveTerm === '1y' ? 'absolute' : ''; ot2c.style.pointerEvents = otActiveTerm === '1y' ? 'none' : ''; }
      if (ot4c) { ot4c.style.display = ''; ot4c.style.opacity = otActiveTerm === '1y' ? '1' : '0'; ot4c.style.position = otActiveTerm === '1y' ? '' : 'absolute'; ot4c.style.pointerEvents = otActiveTerm === '1y' ? '' : 'none'; }
    }

    /* Segment prices - subscription */
    var el;
    var segSubShortPrice = SUP.seg_show_total ? (sysPriceNum + sub6Then) : sub6Then;
    var segSubShortCmp   = SUP.seg_show_total ? (sysFullNum + sub6Cmp) : sub6Cmp;
    var segSubLongPrice  = SUP.seg_show_total ? (sysPriceNum + sub1yThen) : sub1yThen;
    var segSubLongCmp    = SUP.seg_show_total ? (sysFullNum + sub1yCmp) : sub1yCmp;
    var segSubLongOtCmp  = SUP.seg_show_total ? (sysFullNum + ot1y) : ot1y;
    el = wrap.querySelector('[data-seg-sub-6m-price]');
    if (el) el.textContent = fmt(segSubShortPrice, CUR);
    el = wrap.querySelector('[data-seg-sub-6m-compare]');
    if (el) {
      if (sub6Cmp > sub6Then) { el.textContent = fmt(segSubShortCmp, CUR); el.style.display = ''; }
      else { el.textContent = ''; el.style.display = 'none'; }
    }
    el = wrap.querySelector('[data-seg-sub-1y-price]');
    if (el) el.textContent = fmt(segSubLongPrice, CUR);
    el = wrap.querySelector('[data-seg-sub-1y-compare]');
    if (el) {
      if (sub1yCmp > sub1yThen) { el.textContent = fmt(segSubLongCmp, CUR); el.style.display = ''; }
      else if (ot1y > sub1yThen) { el.textContent = fmt(segSubLongOtCmp, CUR); el.style.display = ''; }
      else { el.textContent = ''; el.style.display = 'none'; }
    }

    /* Segment prices - one-time */
    var segOtShortPrice = SUP.seg_show_total ? (sysPriceNum + ot6m) : ot6m;
    var segOtShortCmp   = SUP.seg_show_total ? (sysFullNum + ot6mC) : ot6mC;
    var segOtLongPrice  = SUP.seg_show_total ? (sysPriceNum + ot1y) : ot1y;
    var segOtLongCmp    = SUP.seg_show_total ? (sysFullNum + ot1yC) : ot1yC;
    el = wrap.querySelector('[data-seg-ot-6m-price]');
    if (el) el.textContent = fmt(segOtShortPrice, CUR);
    el = wrap.querySelector('[data-seg-ot-6m-compare]');
    if (el) {
      if (ot6mC > ot6m) { el.textContent = fmt(segOtShortCmp, CUR); el.style.display = ''; }
      else { el.textContent = ''; el.style.display = 'none'; }
    }
    el = wrap.querySelector('[data-seg-ot-1y-price]');
    if (el) el.textContent = fmt(segOtLongPrice, CUR);
    el = wrap.querySelector('[data-seg-ot-1y-compare]');
    if (el) {
      if (ot1yC > ot1y) { el.textContent = fmt(segOtLongCmp, CUR); el.style.display = ''; }
      else { el.textContent = ''; el.style.display = 'none'; }
    }

    /* ── Savings / per-cartridge ── */
    function savingText(label, price, compare) {
      if (compare > 0 && compare > price) {
        var pct = Math.round((1 - price / compare) * 100);
        return label + ' · ' + cfg.dSave + ' ' + pct + '%';
      }
      return label;
    }
    function perDayText(totalPrice, days, cur) {
      var perDay = totalPrice / days;
      return fmt(perDay, cur) + cfg.dPerDay;
    }
    function subPeriodText(subPrice, periodLabel, cur) {
      var thenWord = SUP.then_label || 'Then';
      return thenWord + ' ' + fmt(subPrice, cur) + '/' + periodLabel;
    }
    el = wrap.querySelector('[data-seg-sub-6m-saving]');
    if (el) {
      el.textContent = SUP.seg_show_total ? subPeriodText(sub6Then, SUP.seg_sub_short_period || '4 months', CUR) : perDayText(sub6Then, 180, CUR);
      el.hidden = subTerm !== '6m';
    }
    el = wrap.querySelector('[data-seg-sub-1y-saving]');
    if (el) {
      el.textContent = SUP.seg_show_total ? subPeriodText(sub1yThen, SUP.seg_sub_long_period || '1 year', CUR) : perDayText(sub1yThen, 365, CUR);
      el.hidden = subTerm !== '1y';
    }
    el = wrap.querySelector('[data-seg-sub-6m-perday]');
    if (el) el.textContent = perDayText(sub6Then, 180, CUR);
    el = wrap.querySelector('[data-seg-sub-1y-perday]');
    if (el) el.textContent = perDayText(sub1yThen, 365, CUR);
    el = wrap.querySelector('[data-seg-ot-6m-saving]');
    if (el) el.textContent = perDayText(ot6m, 180, CUR);
    el = wrap.querySelector('[data-seg-ot-1y-saving]');
    if (el) el.textContent = perDayText(ot1y, 365, CUR);

    /* ── Head prices for collapsed cards ── */
    var activeCard = wrap.querySelector('.pov2-card--active');

    /* Subscription head price (visible only when collapsed) */
    var subHeadPrices = wrap.querySelector('[data-mode="sub_only"] [data-head-prices]');
    var subHeadPrice  = wrap.querySelector('[data-head-sub-price]');
    var subHeadCmp    = wrap.querySelector('[data-head-sub-compare]');
    if (subHeadPrices) {
      var subIsCollapsed = !wrap.querySelector('[data-mode="sub_only"]').classList.contains('pov2-card--active');
      subHeadPrices.style.display = subIsCollapsed ? '' : 'none';
      if (subHeadPrice) {
        var subVal = (subTerm === '1y') ? sub1yThen : sub6Then;
        subHeadPrice.textContent = fmt(sysPriceNum + subVal, CUR);
      }
      if (subHeadCmp) {
        var subCmpVal = (subTerm === '1y') ? (sub1yCmp > sub1yThen ? sub1yCmp : (ot1y > sub1yThen ? ot1y : 0)) : (sub6Cmp > sub6Then ? sub6Cmp : 0);
        if (subCmpVal > 0) { subHeadCmp.textContent = fmt(subCmpVal, CUR); subHeadCmp.style.display = ''; }
        else { subHeadCmp.textContent = ''; subHeadCmp.style.display = 'none'; }
      }
    }

    /* One-time head price (visible only when collapsed) */
    var otHeadPrices = wrap.querySelector('[data-mode="onetime"] [data-head-prices]');
    var otHeadPrice  = wrap.querySelector('[data-head-ot-price]');
    var otHeadCmp    = wrap.querySelector('[data-head-ot-compare]');
    if (otHeadPrices) {
      var otIsCollapsed = !wrap.querySelector('[data-mode="onetime"]').classList.contains('pov2-card--active');
      otHeadPrices.style.display = otIsCollapsed ? '' : 'none';
      if (otHeadPrice) {
        var otVal = onetimeTerm === '1y' ? ot1y : ot6m;
        otHeadPrice.textContent = fmt(sysPriceNum + otVal, CUR);
      }
      if (otHeadCmp) {
        var otCmpVal = onetimeTerm === '1y' ? (ot1yC > ot1y ? ot1yC : 0) : (ot6mC > ot6m ? ot6mC : 0);
        if (otCmpVal > 0) { otHeadCmp.textContent = fmt(otCmpVal, CUR); otHeadCmp.style.display = ''; }
        else { otHeadCmp.textContent = ''; otHeadCmp.style.display = 'none'; }
      }
    }

    /* Total row - subscription */
    var subTotalEl = wrap.querySelector('[data-sub-total-price]');
    if (subTotalEl) {
      var subCartVal = activeTerm === '1y' ? sub1yThen : sub6Then;
      subTotalEl.textContent = fmt(sysPriceNum + subCartVal, CUR);
    }

    /* Total row - one-time */
    var otTotalEl = wrap.querySelector('[data-ot-total-price]');
    if (otTotalEl) {
      var otCartVal = otActiveTerm === '1y' ? ot1y : ot6m;
      otTotalEl.textContent = fmt(sysPriceNum + otCartVal, CUR);
    }

    /* CTA price (system + cartridges, or cartridges only if system is free) */
    if (activeCard && btnPrice) {
      var mode = activeCard.getAttribute('data-mode');
      if (mode === 'bundle') {
        var bt = (bundleTerm === '6m') ? (SUP.bundle && SUP.bundle.v6) : (SUP.bundle && SUP.bundle.v3);
        btnPrice.textContent = fmt(centsToUnit((bt && bt.total_cents) || 0), CUR);
      } else {
        var val;
        if (mode === 'sub_only') {
          val = (subTerm === '1y') ? sub1yThen : sub6Then;
        } else {
          val = (onetimeTerm === '1y') ? ot1y : ot6m;
        }
        btnPrice.textContent = fmt(sysPriceNum + val, CUR);
      }
    }

    updateBundleGift(CUR);
    syncBullets();
  }

  /* ── Bundle: refresh gift-box cartridge price + head price for the active term ── */
  function updateBundleGift(CUR) {
    if (!SUP.bundle) return;
    var bt = (bundleTerm === '6m') ? SUP.bundle.v6 : SUP.bundle.v3;
    if (!bt) return;
    var giftP = wrap.querySelector('[data-gift-bundle-cart-price]');
    var giftC = wrap.querySelector('[data-gift-bundle-cart-compare]');
    var headP = wrap.querySelector('[data-head-bundle-price]');
    if (giftP) giftP.textContent = fmt(centsToUnit(bt.total_cents), CUR);
    if (giftC) {
      if (bt.base_cents > bt.total_cents) { giftC.textContent = fmt(centsToUnit(bt.base_cents), CUR); giftC.style.display = ''; }
      else { giftC.textContent = ''; giftC.style.display = 'none'; }
    }
    if (headP) headP.textContent = fmt(centsToUnit(bt.total_cents), CUR);
  }

  /* ── Card switching with animation (Apple-snappy) ── */
  function animateOpen(card) {
    var body = card.querySelector('.pov2-card__body');
    if (!body) return;
    body.style.willChange = 'max-height, opacity';
    body.style.overflow = 'hidden';
    body.style.opacity = '0';
    body.style.maxHeight = '0px';
    void body.offsetHeight;
    body.style.transition = 'max-height .2s cubic-bezier(.2,.8,.3,1), opacity .15s cubic-bezier(.2,.8,.3,1)';
    body.style.maxHeight = body.scrollHeight + 'px';
    body.style.opacity = '1';
    body.addEventListener('transitionend', function handler(e) {
      if (e.propertyName !== 'max-height') return;
      body.removeEventListener('transitionend', handler);
      body.style.maxHeight = 'none';
      body.style.overflow = 'visible';
      body.style.willChange = 'auto';
    });
  }

  function animateClose(card) {
    var body = card.querySelector('.pov2-card__body');
    if (!body) return;
    body.style.willChange = 'max-height, opacity';
    body.style.overflow = 'hidden';
    body.style.maxHeight = body.scrollHeight + 'px';
    void body.offsetHeight;
    body.style.transition = 'max-height .18s cubic-bezier(.2,.8,.3,1), opacity .1s cubic-bezier(.2,.8,.3,1)';
    body.style.maxHeight = '0px';
    body.style.opacity = '0';
    body.addEventListener('transitionend', function handler2(e) {
      if (e.propertyName !== 'max-height') return;
      body.removeEventListener('transitionend', handler2);
      body.style.willChange = 'auto';
    });
  }

  function activateCard(card) {
    if (card.classList.contains('pov2-card--active')) return;
    cards.forEach(function (c) {
      var radio = c.querySelector('.pov2-radio');
      if (c === card) {
        c.classList.add('pov2-card--active');
        if (radio) radio.classList.add('pov2-radio--checked');
        animateOpen(c);
      } else {
        if (c.classList.contains('pov2-card--active')) {
          c.classList.remove('pov2-card--active');
          animateClose(c);
        }
        if (radio) radio.classList.remove('pov2-radio--checked');
      }
    });
    renderPrices();
  }

  /* ── Event listeners ── */
  cards.forEach(function (card) {
    var head = card.querySelector('.pov2-card__head');
    if (head) {
      head.addEventListener('click', function () { activateCard(card); });
      head.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activateCard(card); }
      });
    }
  });

  /* ── Micro-scale punch on segment switch ── */
  function punchScale(el) {
    el.style.transform = 'scale(1.04)';
    requestAnimationFrame(function () {
      setTimeout(function () { el.style.transform = ''; }, 120);
    });
  }

  /* Subscription segments */
  wrap.querySelectorAll('[data-segs="sub"] .pov2-seg').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      if (b.classList.contains('pov2-seg--active')) return;
      subTerm = b.dataset.term;
      b.closest('.pov2-segs').querySelectorAll('.pov2-seg').forEach(function (x) {
        var act = (x === b);
        x.classList.toggle('pov2-seg--active', act);
        x.setAttribute('aria-selected', act ? 'true' : 'false');
      });
      punchScale(b);
      renderPrices();
    });
  });

  /* One-time segments */
  wrap.querySelectorAll('[data-segs="ot"] .pov2-seg').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      if (b.classList.contains('pov2-seg--active')) return;
      onetimeTerm = b.dataset.term;
      b.closest('.pov2-segs').querySelectorAll('.pov2-seg').forEach(function (x) {
        var act = (x === b);
        x.classList.toggle('pov2-seg--active', act);
        x.setAttribute('aria-selected', act ? 'true' : 'false');
      });
      punchScale(b);
      renderPrices();
    });
  });

  /* Bundle segments (3m / 6m) */
  wrap.querySelectorAll('[data-segs="bundle"] .pov2-seg').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      if (b.classList.contains('pov2-seg--active')) return;
      bundleTerm = b.dataset.bterm;
      b.closest('.pov2-segs').querySelectorAll('.pov2-seg').forEach(function (x) {
        var act = (x === b);
        x.classList.toggle('pov2-seg--active', act);
        x.setAttribute('aria-selected', act ? 'true' : 'false');
      });
      punchScale(b);
      renderPrices();
    });
  });

  /* ── Init ── */
  cards.forEach(function (c) {
    var body = c.querySelector('.pov2-card__body');
    if (!body) return;
    if (c.classList.contains('pov2-card--active')) {
      body.style.maxHeight = 'none';
      body.style.overflow = 'visible';
    } else {
      body.style.maxHeight = '0px';
      body.style.overflow = 'hidden';
    }
  });

  /* ── Color swatches (Color option of main product) ─────────────────────── */
  var COLORS = (S.colors && S.colors.length) ? S.colors : [];
  var currentColor = COLORS.length ? COLORS[0].name : null;

  /* ── Preload color-specific images so swatch clicks are instant ─── */
  var _preloadedMediaIds = {};
  var _preloadedSysImgs = {};
  function preloadGalleryMedia(mediaId) {
    if (!mediaId || _preloadedMediaIds[mediaId]) return;
    var item = document.querySelector('.product-gallery__media[data-media-id="' + mediaId + '"]');
    if (!item) return;
    item.querySelectorAll('img').forEach(function (img) {
      if (img.loading === 'lazy') img.loading = 'eager';
      if (img.fetchPriority === 'auto') img.fetchPriority = 'low';
      if (!img.complete && img.src) {
        var pre = new Image();
        if (img.sizes)  pre.sizes  = img.sizes;
        if (img.srcset) pre.srcset = img.srcset;
        pre.src = img.src;
      }
    });
    _preloadedMediaIds[mediaId] = true;
  }
  function preloadSystemImage(url) {
    if (!url || _preloadedSysImgs[url]) return;
    var pre = new Image();
    pre.src = url;
    _preloadedSysImgs[url] = true;
  }
  function preloadColor(c) {
    if (!c) return;
    if (c.media_id)     preloadGalleryMedia(c.media_id);
    if (c.system_image) preloadSystemImage(c.system_image);
  }
  function preloadAllColorMedia() { COLORS.forEach(preloadColor); }

  function buildColorSwatches(slot) {
    if (!slot || COLORS.length === 0) { if (slot) slot.style.display = 'none'; return; }
    slot.innerHTML = '';
    var title = document.createElement('span');
    title.className = 'pov2-color-slot__title';
    title.innerHTML = 'COLOR<strong data-color-name>' + (currentColor || '') + '</strong>';
    slot.appendChild(title);
    var inner = document.createElement('div');
    inner.className = 'pov2-color-swatchwrap';
    COLORS.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button';
      var vp = c.variant_id && S.variantPrices ? S.variantPrices[String(c.variant_id)] : null;
      var isSoldOut = vp ? vp.available === false : false;
      b.className = 'pov2-color-swatch' + (c.name === currentColor ? ' pov2-color-swatch--active' : '') + (isSoldOut ? ' pov2-color-swatch--sold-out' : '');
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', c.name === currentColor ? 'true' : 'false');
      b.setAttribute('aria-label', c.name + (isSoldOut ? ' - Sold out' : ''));
      b.setAttribute('aria-disabled', isSoldOut ? 'true' : 'false');
      b.dataset.color = c.name;
      if (c.variant_id) b.dataset.variantId = c.variant_id;
      if (c.media_id)   b.dataset.mediaId   = c.media_id;
      b.style.setProperty('--swatch-color', c.swatch || '#cccccc');
      b.innerHTML = '<span class="pov2-color-swatch__dot" aria-hidden="true"></span><span class="pov2-color-swatch__label">' + c.name + '</span>';
      b.addEventListener('click', function (e) { e.stopPropagation(); selectColor(c.name); });
      /* Aggressive preload on intent signals — guarantees both the gallery
         media and the gift-box system thumbnail are cached before click. */
      var _hoverPreload = function () { preloadColor(c); };
      b.addEventListener('mouseenter', _hoverPreload);
      b.addEventListener('touchstart', _hoverPreload, { passive: true });
      b.addEventListener('focus', _hoverPreload);
      inner.appendChild(b);
    });
    slot.appendChild(inner);
  }

  function ensureColors() {
    wrap.querySelectorAll('.pov2-color-slot').forEach(function (slot) {
      if (!slot.dataset.built) { buildColorSwatches(slot); slot.dataset.built = '1'; }
    });
  }

  function syncSwatchActiveState() {
    wrap.querySelectorAll('.pov2-color-swatch').forEach(function (el) {
      var on = el.dataset.color === currentColor;
      el.classList.toggle('pov2-color-swatch--active', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    wrap.querySelectorAll('[data-color-name]').forEach(function (el) {
      el.textContent = currentColor || '';
    });
  }

  function selectColor(name) {
    if (!name) return;
    var _c = COLORS.find(function (x) { return x.name === name; });
    if (_c && _c.variant_id && S.variantPrices) {
      var _vp = S.variantPrices[String(_c.variant_id)];
      if (_vp && _vp.available === false) return;
    }
    currentColor = name;
    syncSwatchActiveState();
    var c = COLORS.find(function (x) { return x.name === name; });
    if (!c) return;
    /* 1) Nudge the native variant-picker radio (theme will then filter the
          gallery via #<OptionName>_<value> alt-text pattern in product-gallery.liquid). */
    var optName = (S.colorOptionName || 'Color');
    var sel = 'input[type="radio"][name="options[' + optName + ']"]';
    document.querySelectorAll(sel).forEach(function (r) {
      if (r.value === name) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    /* 2) Dispatch variant:change so this and other widgets re-render. */
    if (c.variant_id) {
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: { id: Number(c.variant_id) || c.variant_id } } }));
    }
    /* 3) Swap the gift-box "system" thumbnail to match the selected color. */
    swapSystemImage(c);
    /* 4) Filter the gallery and navigate via the theme's native carousel API
          (carousel:filter + control:select events on <media-carousel>). */
    filterGalleryByColor(name);
  }

  function swapSystemImage(c) {
    if (!c || !c.system_image) return;
    /* Both cards have a [data-system-img] in their gift box. Update both so
       the right image is in place when the user opens the other card. */
    wrap.querySelectorAll('[data-system-img]').forEach(function (img) {
      if (img.getAttribute('src') !== c.system_image) {
        img.setAttribute('src', c.system_image);
      }
      img.setAttribute('alt', (c.name || '') + ' filter');
    });
  }

  function filterGalleryByColor(colorName) {
    var colorMediaIds = {};
    var hasColors = false;
    COLORS.forEach(function (c) {
      if (c.media_id) { colorMediaIds[String(c.media_id)] = true; hasColors = true; }
    });
    if (!hasColors) return;

    var current = COLORS.find(function (x) { return x.name === colorName; });
    var currentId = (current && current.media_id) ? String(current.media_id) : null;

    document.querySelectorAll('media-carousel').forEach(function (carousel) {
      var items = Array.from(carousel.querySelectorAll('.product-gallery__media'));
      if (!items.length) return;

      var filteredIndexes = [];
      var targetIndex = -1;
      items.forEach(function (item, index) {
        var id = item.getAttribute('data-media-id');
        if (colorMediaIds[id]) {
          if (id === currentId) { targetIndex = index; }
          else                  { filteredIndexes.push(index); }
        }
      });

      /* First non-filtered index (used when no specific media for this color,
         e.g. Gray): we want to land on the gallery default (position 1). */
      var firstVisible = -1;
      for (var i = 0; i < items.length; i++) {
        if (filteredIndexes.indexOf(i) === -1) { firstVisible = i; break; }
      }

      /* Tell the carousel which slides are filtered (hide them). */
      carousel.dispatchEvent(new CustomEvent('carousel:filter', {
        detail: { filteredIndexes: filteredIndexes }
      }));

      /* Mirror the filter on the page-dots so the dot count matches. */
      var gallery = carousel.closest('product-gallery');
      if (gallery) {
        gallery.querySelectorAll('page-dots').forEach(function (dots) {
          dots.dispatchEvent(new CustomEvent('control:filter', {
            detail: { filteredIndexes: filteredIndexes }
          }));
        });
      }

      /* Navigate to the right slide:
         - if this color has a specific image → go to it,
         - else go to the first visible (default gallery / Gray case). */
      var navIndex = targetIndex >= 0 ? targetIndex : firstVisible;
      if (navIndex >= 0) {
        carousel.dispatchEvent(new CustomEvent('control:select', {
          bubbles: true, cancelable: true, detail: { index: navIndex }
        }));
      }
    });
  }

  /* ── Hide the native variant-picker fieldset for the color option ───────
     Our pov2 widget renders inline color swatches in the gift box, so the
     native picker is redundant.

     Timing: this script runs INLINE while the page is still parsing, BEFORE
     the variant-picker section is rendered. We must wait — either until
     DOMContentLoaded, or via a body MutationObserver that fires when the
     <variant-picker> element finally lands in the DOM.

     We match by <legend> text because Shopify's variant-picker uses opaque
     option1/option2 input names (no data attribute for the option name). */
  var COLOR_LEGENDS = ['color', 'tap color', 'couleur', 'colour', 'couleur du robinet'];
  function hideNativeColorPicker() {
    var hidAny = false;
    document.querySelectorAll('variant-picker fieldset.variant-picker__option').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (!legend) return;
      var text = (legend.textContent || '').toLowerCase().replace(/[:\s]+$/, '').trim();
      if (COLOR_LEGENDS.indexOf(text) !== -1) {
        if (fs.style.display !== 'none') { fs.style.display = 'none'; hidAny = true; }
      }
    });
    return hidAny;
  }
  function setupColorPickerHider() {
    /* Try right now (may already be in DOM if script is mounted after the picker). */
    hideNativeColorPicker();
    /* Watch the body for newly-inserted variant-picker / option fieldsets and
       any future updates to existing ones (e.g. Shopify section re-render). */
    var bodyObs = new MutationObserver(function () { hideNativeColorPicker(); });
    bodyObs.observe(document.body, { childList: true, subtree: true });
    /* Defensive: re-run after the theme dispatches variant:change. */
    document.addEventListener('variant:change', hideNativeColorPicker);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupColorPickerHider);
  } else {
    setupColorPickerHider();
  }

  ensureColors();
  /* Initial gallery filter: hide color-specific media for non-default colors. */
  if (currentColor) filterGalleryByColor(currentColor);
  /* Background preload of all color media after page settles. requestIdleCallback
     ensures we don't compete with critical resource loads on slow devices. */
  if (window.requestIdleCallback) {
    window.requestIdleCallback(preloadAllColorMedia, { timeout: 2500 });
  } else {
    setTimeout(preloadAllColorMedia, 800);
  }

  renderPrices();
  requestAnimationFrame(function () { wrap.setAttribute('data-ready', '1'); });
  setTimeout(function () { wrap.setAttribute('data-ready', '1'); }, 240);

  /* ── Live inventory fetch — overrides Liquid-cached available values ── */
  fetch('/products/' + cfg.productHandle + '.js')
    .then(function (r) { return r.json(); })
    .then(function (product) {
      var changed = false;
      (product.variants || []).forEach(function (v) {
        var key = String(v.id);
        if (S.variantPrices && S.variantPrices[key] && S.variantPrices[key].available !== !!v.available) {
          S.variantPrices[key].available = !!v.available;
          changed = true;
        }
      });
      if (changed) {
        /* Rebuild swatches with correct sold-out state */
        wrap.querySelectorAll('.pov2-color-slot').forEach(function (slot) {
          slot.removeAttribute('data-built');
          buildColorSwatches(slot);
          slot.dataset.built = '1';
        });
        renderPrices();
      }
    })
    .catch(function () {});

  /* ── Variant change listener ── */
  document.addEventListener('variant:change', function (e) {
    var vid = e && e.detail && e.detail.variant ? e.detail.variant.id : null;
    if (vid && S.variantPrices && S.variantPrices[String(vid)]) {
      currentVariantId = vid;
      renderPrices();
    }
    /* If the new variant has a known color, reflect it in the swatches. */
    if (vid && COLORS.length) {
      var matched = COLORS.find(function (x) { return String(x.variant_id) === String(vid); });
      if (matched && matched.name !== currentColor) {
        currentColor = matched.name;
        syncSwatchActiveState();
      }
    }
  });
  document.querySelectorAll('input[name="id"], select[name="id"]').forEach(function (el) {
    el.addEventListener('change', function () {
      if (S.variantPrices && S.variantPrices[String(el.value)]) {
        currentVariantId = el.value;
        renderPrices();
      }
    });
  });

};
(function () {
  var q = window.PuurePov2BundleQueue = window.PuurePov2BundleQueue || [];
  for (var i = 0; i < q.length; i++) { try { window.PuurePov2BundleInit(q[i]); } catch (e) { console.error(e); } }
  q.push = function (cfg) { try { window.PuurePov2BundleInit(cfg); } catch (e) { console.error(e); } return 0; };
})();
